export default "__VITE_ASSET__BLLvPpqK__"